export class ContactViewModel {
    FullName: string;
    Email: string;
    Phone: string;
    Message: string;
}